import { render, staticRenderFns } from "./AlertBubbles.vue?vue&type=template&id=03384306&"
import script from "./AlertBubbles.vue?vue&type=script&lang=js&"
export * from "./AlertBubbles.vue?vue&type=script&lang=js&"
import style0 from "./AlertBubbles.vue?vue&type=style&index=0&id=03384306&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports